export const InitSymptomRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
      {
        path: "/manage/symptoms",
        name: "symptom",
        component: () => import("@/pages/manage/symptoms/index.vue"),
        meta: {
          requiresAuth: true,
          roles: [config.roles.administrators, config.roles.siteEditors],
        },
      },
      {
        path: "/manage/symptoms/:id",
        name: "symptom-id",
        component: () => import("@/pages/manage/symptoms/id.vue"),
        meta: {
          requiresAuth: true,
          roles: [config.roles.administrators, config.roles.siteEditors],
        },
      },
    ];
